import VModal from '@/vuetify_custom/v-modal_v1'
import { VBtn} from 'vuetify/lib'
import {mapGetters} from "vuex";
import { DATE_DAY_FORMATE } from '@/libs/constants'
import { handleEditData, createContractSettlementsParams, createContractInvoiceParams } from '../utils'
import mixin_fields from './EditNextModalMixin'
import EditNextBaseInfoModal from './EditNextBaseInfoModal'
import EditNextSecondModal from './EditNextSecondModal'
import EditNextThridModal from './EditNextThridModal'
import EditNextFourthModal from './EditNextFourthModal'
import EditNextInvoicesModal from './EditNextInvoicesModal'
import EditNextSixthModal from './EditNextSixthModal'
import EditNextSevenModal from './EditNextSevenModal'
// import PutInRecordsModal from './PutInRecordsModal'
import BlogAdditionModal from './BlogAdditionModal'
// import EditNextEightModal from './EditNextEightModal'
import EditNextNineModal from './EditNextNineModal'
import CommodityInfo from '@/views/business/components/CommodityInfo.jsx'
import VTips from './VTips'
import { submitContracSaveApi } from '../service'
import { handleContractAttrs, createContractParams, handleSubmitData, createStockParams } from '../utils'
import { CONTRACT_SEAL_APPLICATION, GENERATE_CONTRACT_CHILD, COURSE_WITHOUT_STOCK, CLOSE } from '../constants'
import styles from './index.module.less'
const EXPENSE = 'expense'
const index_c = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
// form-contain

export default {
    mixins:[mixin_fields],
    data() {
       //  this.virtualContractChild = null
        return {
            need_draft: false, // 草稿箱
            show: false,
            saving: false,
            params: {},
            show_type: false,
            // contract_attrs_hash: {},
            source_apply_user_arr: [],
            source_account_arr:[],
            virtual_contract_child_source_total_price: null,
        }
    },
    computed: {
        ...mapGetters({
            contract_types: 'async/contract_types',
            team_company_mapping_hash:  'async/team_company_mapping_hash',
            
          }),
        contract_attrs_hash() {
            return handleContractAttrs(this.contract_types)
        },
        attrs_list() {
            if (!this.params.balance_type) {
                return []
            }
            return this.contract_attrs_hash[this.params.balance_type] || []
        },
        cur_customer() {
            return this.$store.state.cur_customer;
          },
        is_financer() {
            return this.cur_customer.groups && this.cur_customer.groups.includes('GROUP_FIN');
        },
    },
    created() {
        this.attrs_list
        this.team_company_mapping_hash
        this.contract_types
    },
    mounted() {

    },
    methods: {
        generateFromBlogRecords(data) {
            data = data || []
            this.initParams()
            setTimeout(() => {
                this.$refs['2']._selectedTargetType()
            }, 1000)
          
            this.params.contract_sz_type = 'expense'
            this.params.contract_nature = 'close'
            this.params.contract_type_bread_id = 'stockless'
            this.params.ads_record_ids = data.map(i => i.id)
            if (this.params.ads_record_ids) {
               this.$set(this.params, 'ads_record_ids', this.params.ads_record_ids)
            }
            this.edit(this.params)
            this.show = true
        },
        initParams() {
            this.params = createContractParams()
            // 制表人
            if (this.cur_customer.is_formal) {
                this.params.apply_user_id = this.cur_customer.id
                this.params.apply_user = this.cur_customer.account
                this.params.principal = this.cur_customer.account
            }
            this.params.fill_user = this.cur_customer.account
            // 申请人
            // this.params.apply_user_id = this.cur_customer.id
            // this.params.apply_user = this.cur_customer.account
            this.params.team_id = this.cur_customer.team_info.root_id
            // this.params.company_id = this.cur_customer.company_id
            const team_company_mapping_hash = this.team_company_mapping_hash
            const company = team_company_mapping_hash.companyTeamCorrespondGetCompant(this.params.team_id)
            this.params.company_id = company && company.company_id 
          },
        scrollTo() {
            const c_height = this.$refs['some-c'].offsetHeight
            this.$refs.contain.scrollTo({top: c_height, behavior: 'smooth'})
        },
        handleFromMainChild({params, contract}) {
            params = JSON.parse(JSON.stringify(params))
            // 初始化参数
            params.contract_type_bread_id = 'virtual',
            params.contract_type_id = '',
            params.virtual_contract_type = 1, // 虚拟合同由 
            params._contract_generate_type = GENERATE_CONTRACT_CHILD,
            params.id = null,
            params.uid = null,
            params.name = null,
            params.total_price = null,
            params.fill_user = this.cur_customer.account,
            params.zhibiao_date = moment(params.created_at).format(DATE_DAY_FORMATE), 
            params.contract_settlements = [createContractSettlementsParams()],
            params.contract_invoices = [createContractInvoiceParams()],
            this.contract_types.forEach(i => {
                if (i.main_type === 'virtual' &&
                  !params.contract_type_id &&
                  i.sub_type.includes('由主合同生成')
                ) {
                  params.contract_type_id = i.id
                }
              })
            this.virtual_contract_child_source_total_price = Number(contract.total_price),
            // 填充params
            this.edit(params, {
                need_draft:true,
            }),
            // 复用由关联合同生成虚拟合同的逻辑
            this.$nextTick(() => {
                this.handleFromMain(contract)
            })
        },
        // 从合同来的
        handleFromMain(contract) {
              contract = JSON.parse(JSON.stringify(contract))
              const from_now_arr = [
              'id',
              'contract_sz_type', 
              'zhibiao_date', 
              'fill_user', 
              'contract_type_bread_id', 
              'virtual_contract_type', 
              'contract_type_id',
              'contract_nature',
              'apply_user',
              'apply_user_id',
              'team_id',
              'name',
              'uid',
              'company_id',
              'link_contracts',
              'total_price',
              'contract_invoices',
              'bfiles',
              '_contract_generate_type',
              'contract_settlements',
           ]
              const params_c = handleEditData(contract)
              from_now_arr.forEach(key => {
               params_c[key] = this.params[key]
              })
              params_c.id = null
                //  this.params = params_c
              params_c.link_contracts = [contract]
              params_c.contract_stocks = [createStockParams()]
              params_c.show_stock = false
              this.edit(params_c)
           },

        edit(data, o_p = {  
            need_draft:false,
        }) {
        
            this.need_draft = o_p.need_draft            
            this.params = data
            if (this.params.apply_user_id) {
                this.source_apply_user_arr = [
                    {
                        account: this.params.apply_user,
                        id: this.params.apply_user_id
                    }
                ]
            }
            if (data.account_id && data.account_name) {
                this.source_account_arr = [
                    {
                        text_name: this.params.account_name,
                        id: this.params.account_id
                    }
                ]
            }
            this.show = true
            this.$nextTick(() => {
                (this.params.link_contracts || []).forEach((item, index) => {
                    this.$refs['6'].changeUid(item, index)
                })
                const draft_link_contracts = this.params.draft_link_contracts || []
                this.need_draft && Object.values(draft_link_contracts).forEach(item => {
                    this.$refs['6'].setHash(item)
                })
                 // setHash
                index_c.forEach(item => {
                    item = item.toString()
                    this.$refs[item] && this.$refs[item].init && this.$refs[item].init()
                    this.$refs[item] && this.$refs[item].resetValidation && this.$refs[item].resetValidation()
                })
            })
        },
        validate() {
            let go = true
            index_c.forEach(item => {
                item = item.toString()
                if (!this.$refs[item] || !this.$refs[item].validate) {
                    return 
                }
                 const c_go = this.$refs[item].validate() 
                 if (!c_go) {
                    go = false
                 }
            })
            if (!go) {
                this.$Message.warning({
                    content: '存在未通过校验，请仔细阅读字段下的提示语，按照提示语填写后才可保存!'
                  });
            }
            return go
        },

        submit() {
            const _this = this
            if (this.params.show_stock && !this.params.bill_type) {
                this.$vModal.error({title: '提示', content: '存货-订单类型必选'});
                return 
            }
            if (this.validate()) {
              const params = handleSubmitData(JSON.parse(JSON.stringify(this.params)))
              if (this.params.virtual_contract_type === 1 && !this.params.id) {
                // params.consume_schedule && (params.consume_schedule.id = null)
                params.contract_recharge && (params.contract_recharge.id = null)
                params.contract_settlements = params.contract_settlements && params.contract_settlements.map(item => ({...item, id: null}))
                params.contract_invoices = params.contract_invoices && params.contract_invoices.map(item => ({...item, id: null}))
              }
              
              if (this.params.virtual_contract_type === 4) {
                const total_price = Number(params.total_price)
                const max = this.is_financer ? 50000 : 5000
                if (total_price > max) {
                    this.$vModal.error({
                        title:'提示',
                        content: `该类别合同不可超过${ this.$util.formatNumber(max)},若超过，需按标准合同用章申请流程处理～`
                    })
                    return 
                }
              }
              this.saving = true
              submitContracSaveApi(params).then((res) => {
                  this.show = false
                  this.$emit('success')
                  if (this.params._created_time) {
                    let list = []
                    try {
                        list = JSON.parse(localStorage.getItem(`${CONTRACT_SEAL_APPLICATION}/${this.cur_customer.id}`)) || []
                    } catch (error) {
                        list = []
                    }
                    list = list || []
                    list = list.filter(item => {
                        return Number(item._created_time) !== Number(this.params._created_time)
                    })
                    localStorage.setItem(`${CONTRACT_SEAL_APPLICATION}/${this.cur_customer.id}`, JSON.stringify(list))
                  }
                  this.$Message.success({
                    content: '数据保存成功!'
                  });
            
                  if (this.params.contract_type && this.params.contract_type.sub_type === '广告合同') {
                    _this.$emit('needTfModal', res)
                  }
              }).finally(() => {
                this.saving = false
              })
            }
        }
    },
    render() {
        const _this = this
        return <VModal
            fullscreen
            v-model={_this.show}
            title={_this.params.id ? '编辑合同' : '创建合同'}
            loading={_this.saving}
            width={600}
            ref="modal"
            ok-text="保存"
            on={{
                ok: () => {
                    this.submit() 
                },
                cancel:() => {
                   _this.params = createContractParams()
                }
            }}
            scopedSlots={{
                footer:() => {
                    return <div style="width:100%;display:flex">
                            <div style="flex:1"/>
                            <VBtn
                                on={{
                                    click:() => {
                                        this.show = false
                                        this.need_draft = false
                                        _this.params = createContractParams()
                                    }
                                }}

                            >
                                取消
                            </VBtn>
                            <space />
                           { this.need_draft && !_this.params.id && <VBtn
                                
                                color="primary"
                                on={{
                                    click:() => {
                                        let list = []
                                        try {
                                            list = JSON.parse(localStorage.getItem(`${CONTRACT_SEAL_APPLICATION}/${this.cur_customer.id}`)) || []
                                        } catch (error) {
                                            list = []
                                        }
                                        if (!_this.params._created_time) {
                                       
                                            _this.params._created_time = +new Date()
                                            _this.params._updated_time = +new Date()
                                            list.push(_this.params)
                                        } else {
                                            _this.params._updated_time = +new Date()
                                            list = list.map(item => {
                                                if (Number(item._created_time) === Number(_this.params._created_time)) {
                                                    return _this.params
                                                }
                                                return item
                                            })
                                        }   
                                        localStorage.setItem(`${CONTRACT_SEAL_APPLICATION}/${this.cur_customer.id}`, JSON.stringify(list))
                                        _this.$Message.success('草稿保存成功！')
                                    }
                                }}
                            > 
                                保存草稿
                            </VBtn>}
                            <space />
                            <VBtn
                                color="primary"
                                loading={this.saving}
                                on={{
                              
                                    click:() => {
                                        _this.submit() 
                                    }
                                }}
                            > 
                                保存
                            </VBtn>
                    </div>
                }
            }}
        >
        <div class={styles['contain']} ref="contain">    
            <div class={styles['fixed-tip']}>
                <VTips>
                    <div style="margin-bottom:10px">
                        <a
                        href="https://shimo.im/docs/293DVzRxJdhLFRk4"
                        target="__blank"
                        >合同开票申请指南</a>
                    </div>
                    <div>
                        <a
                        href="https://shimo.im/docs/wDp9JhwaPAY3ndyM"
                        target="__blank"
                        >合同与付款流程操作指南</a>
                    </div>
                </VTips>
            </div>
            <div class={styles['form-contain']}>
                <div ref="some-c">
                    {/* 制表信息 */}
                    <div class={styles['block-contain']}>
                        <EditNextBaseInfoModal
                            ref="1"
                            defaultApply = {this.source_apply_user_arr}
                            v-model={_this.params}
                        />
                    </div>
                    <hr/>
                    {/* 基本信息 */}
                    <div class={styles['block-contain']}>
                            <EditNextSecondModal
                                ref="2"
                                v-model={_this.params}
                                defaultAccount={_this.source_account_arr}
                                virtualContractChildSourceTotalPrice={_this.virtual_contract_child_source_total_price}
                                on={{
                                    selectVirtual:_this.scrollTo
                                }}
                            />  
                    </div>
                    <hr/>
                {/* 充值信息 */}
                { _this.params.is_recharge && <EditNextThridModal
                    ref="3"
                    v-model={_this.params}
                />}
                {/* 合同结算款项 */}
                 { _this.params.contract_nature === CLOSE && <EditNextFourthModal
                   ref="4"
                  v-model={_this.params}
                /> }
                {/* 商品信息 */}

                {_this.params.contract_type_bread_id === COURSE_WITHOUT_STOCK && _this.params.contract_nature === CLOSE && <CommodityInfo ref="10" v-model={_this.params}/>}
                {/* 投放记录 */}
                {/* <PutInRecordsModal ref="9" v-model={_this.params}/> */}
                {/* 加成服务 */}
                {!!_this.params.placing_ads_vas_records && !!_this.params.placing_ads_vas_records.length && <BlogAdditionModal v-model={_this.params}/>}
                {/* 发票信息 */}
                {/* 支出类合同 */}
                { 
                  (
                    _this.params.contract_sz_type === EXPENSE || 
                    _this.params.contract_nature === CLOSE
                  ) && <EditNextInvoicesModal
                    ref="5"
                    v-model={_this.params}
                    />}
                </div>
                {/*  关联合同 */}
                 <div class={styles['vitural-contain']}> 
                    <EditNextSixthModal
                        ref="6"
                        v-model={_this.params}
                        on={{
                            handleFromMain:_this.handleFromMain
                        }}
                 />
                 </div>
                 {/* 存货 */}
                 { (_this.params.show_stock || _this.params.is_virtual_stock) && <EditNextSevenModal
                    ref="7"
                    v-model={_this.params}
                 />}
                 {/* 财务 */}
                 {_this.is_financer && <EditNextNineModal 
                       ref="8"
                       v-model={_this.params}
                />}
            
            </div>
        </div>
        </VModal>
    }
}